import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    redirectTo: '/test',
    pathMatch: 'full'
  },
  {
    path: 'test',
    loadChildren: () => import('./main/test/test.module').then(m => m.TestModule)
  },
  {
    path: 'bgv',
    loadChildren: () => import('./main/bgv/bgv.module').then(m => m.BgvModule)
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
